/**
 * Domain types for a conversation turn.
 *
 * The wire envelope is validated against the backend's OpenAPI schema (see
 * `schema.ts`, regenerated by `npm run gen:api`). `options` is typed loosely
 * there (`list[dict]`), so we narrow it to `Option` here — the one place the
 * frontend asserts the option shape the engine actually emits.
 */
export interface Option {
  text: string;
  value?: string | number | boolean | null;
  next?: string;
  /** Present on comparison-card choices (WW/C2W); used in phase 3. */
  description?: string;
  /** External resource URL for comparison-card choices (WW/C2W "Find out more"). */
  link?: string;
}

export interface Turn {
  session_id: string;
  message: string;
  node_type: string;
  options?: Option[] | null;
  subtext?: string | null;
  multi_select: boolean;
  allow_free_text: boolean;
  terminal: boolean;
  crisis: boolean;
  service_recommended?: string | null;
  acknowledgment?: string | null;
  preamble: string[];
  node_id?: string | null;
  data_field?: string | null;
  validation?: Record<string, unknown> | null;
  /**
   * Journey progress for the bar (PROJ-155); null on the welcome screen.
   * `fraction` (0–1) is how far to fill and advances on every question, not
   * only when the stage changes. `step`/`of` remain the announced position.
   */
  progress?: { step: number; of: number; fraction?: number; complete: boolean } | null;
  collected_data?: Record<string, unknown> | null;
}

/** Error carrying the HTTP status so callers can distinguish 404/5xx/network. */
export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number | null,
  ) {
    super(message);
    this.name = "ApiError";
  }
}
